export interface SummaryConfig {
    totalPrice: boolean;
    continueButtonText: string;
    disclaimerText?: string;
}

// Converts JSON strings to/from your types
export class Convert {
    public static toSummaryConfig(json: string): SummaryConfig {
        return JSON.parse(json);
    }

    public static summaryConfigToJson(value: SummaryConfig): string {
        return JSON.stringify(value);
    }
}
